/* eslint-disable */
import React, { useState } from 'react';
import moment from 'moment';
import {
  makeStyles,
  Box,
  IconButton,
  Typography,
  Snackbar
} from '@material-ui/core';
import { userInfoSelector } from 'redux/custom-selector';
import { setUserInfo } from 'redux/actions/user-action';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { API, POSTAPIWITHCUSTOMDOMAIN } from 'api-setup/api-helper';
import { MANAGE_SUBSCRIPTION, UPGRADE_MODAL_ACTIONS } from 'api-setup/api-endpoints';
import NotificationBar from '../custom-components/notificationToaster';
import WPlusSidebar from './layout-components/WPlusSidebar';
import { setNewMessage } from 'redux/actions/setting-actions';
import ProjectSetting, { supportEmail } from 'settings';
import { useSource } from 'lib/custom-common-hooks';
import { IFramePopup } from 'custom-components/popUp';
import ErrorIcon from '@material-ui/icons/Error';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { PricingPlan, SECONDARY_PLAN_LIST } from 'constants/pricingPlan';
import { setSurvey } from 'redux/actions/survey-actions';
import { useAmplitudeInstance } from 'lib/amplitude/use-amplitude-instance';
import { planExpireTypeDisplay, planTypeDisplay } from '../lib/common-function';
import { TIMESTAMP_FORMATS } from 'utility/formatTime';
import { XIcon } from '@phosphor-icons/react';
import WPlusHeader from './layout-components/WPlusHeader';
import BlurryBlobBackground from 'custom-components/blurryBlobBackground';


const useStyles = makeStyles((theme) => ({
  dashHeader: {
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    height: 60,
    borderBottom: `1px solid ` + theme.palette.border.light,
    zIndex: 15,
    '&.sidebar-not-available': {
      left: 0,
    },
  },
  tagEventNameForPopup: {
    background: theme.palette.primary.main,
    color: '#fff',
    padding: '0.3rem 0.2rem',
    marginRight: '0.3rem',
    borderRadius: theme.shape.borderRadius,

    '& h6': {
      fontSize: '14px',
      lineHeight: 1,
    },
  },
  tagEventNameForHeader: {
    color: '#fff',
  },
  borderForProfile: {
    borderBottom: `1px solid ${theme.palette.bg.whiteOff2}`,
  },
  previewBtn: {
    marginLeft: '5px',
    fontSize: '13px',
  },
  leftAside: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  w100: {
    width: '100%',
  },
  feedBackForm: {
    cursor: 'pointer',
    textDecoration: 'underline',
    marginLeft: '5px',
  },
  logoBlock: {
    color: theme.palette.text.third,
    '& .event-logo': {
      '& svg': {
        cursor: 'pointer',
        width: 140,
        height: 50,
      },
    },
    '& :hover': {
      '& .logo-icon': {
        color: theme.palette.primary.main,
      },
      '& .logo-text': {
        color: theme.palette.primary.main,
      },
    },
    '& .logo-text': {
      fontSize: 19,
      lineHeight: 'normal',
      overflow: 'hidden',
      maxWidth: '300px',
      fontWeight: 700,
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(3),
    },
  },
  rightMenuAction: {
    minWidth: 60,
    color: theme.palette.text.third,
    position: 'relative',
    // borderLeft: '1px solid ' + theme.palette.border.light,
    // '& .badgeForNewItem': {
    //   '& .MuiBadge-badge ': {
    //     height: 17,
    //     width: 17,
    //     minWidth: 17,
    //     border: '1px solid #fff',
    //   },
    // },
    '& .dash-header-right-action': {
      "&:hover": {
        borderRadius: '0rem'
      },
      "&.lang-btn": {
        padding: `${theme.spacing(0)}px ${theme.spacing(1)}px`,
      },
      '& .langGlobeIcon': {
        '& svg': {
          width: `16px`,
          height: `16px`,
        },
      },
      '& .warnIcon': {
        '& svg': {
          width: `25px`,
          height: `25px`,
          color: theme.palette.primary.main,
        },
      },

      padding: `0`,
      fontSize: 14,
      // minWidth: 60,
      borderRadius: 0,
      textTransform: 'capitalize',
      '& .ml10': {
        paddingLeft: '10px',
        overflow: `hidden`,
        textOverflow: `ellipsis`,
        whiteSpace: `nowrap`,
      },
    },
    '& .expired-btn': {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      backgroundColor: theme.palette.alert.alertWarnBg,
      color: theme.palette.primary.light,
      fontSize: theme.fontSize.size9,
      fontWeight: 500,
    },
  },
  closeBtn: {
    padding: theme.spacing(0.3),
    width: 30,
  },
  avatarBadge: {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid #fff`,
    borderRadius: 0,
    height: 20,
    width: 20,
    right: 13,
    bottom: -6,
    '& h6': {
      fontSize: '8px',
    },
  },
  userAvatar: {
    width: 36,
    height: 36,
    marginLeft: theme.spacing(3),
    borderRadius: 0,
    //	border: '1px solid ' + theme.palette.border.lighter,
    '& .MuiAvatar-img': {
      height: 'auto',
    },
  },

  userAvatar2: {
    width: 36,
    height: 36,
    marginRight: theme.spacing(0.5),
    borderRadius: 30,
    //	border: '1px solid ' + theme.palette.border.lighter,
    '& .MuiAvatar-img': {
      height: 'auto',
    },
  },
  rightAsideOtherAction: {
    '& .event-btn': {
      marginLeft: 8,
      '&:last-child': {
        marginLeft: 8,
      },
      borderRadius: 0,
      fontFamily: 'Libre Franklin',
      background: 'none',
      color: theme.palette.text.primary,
      fontWeight: '500'
    },
    '& .plan-btn': {
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(1),
      marginLeft: 10,
      backgroundColor: theme.palette.alert.alertWarnBg,
      color: theme.palette.primary.light,
      paddingLeft: 10,
      paddingRight: 10,
      '&:last-child': {
        marginRight: 10,
      },
      '& svg': {
        fontSize: '20px',
      },
    },
    '& .header-addition-action': {
      // marginRight: 20,
      // '& button': {
      // 	'&:hover': {
      // 		backgroundColor: theme.palette.bg.whiteOff1,
      // 		color: theme.palette.primary.light,
      // 	}
      // }
      '& .goLiveBtn': {
        marginLeft: theme.spacing(1),
      },
      '& .btn-event': {
        // backgroundColor: theme.palette.bg.whiteOff1,
        backgroundColor: 'var(--vpro-menu-bg-color)',
        fontWeight: '700',
        '&:focus': {
          outlineColor: 'var(--vpro-section-color) !important',
        }

      },
    },
  },
  dashContentWrapper: {
    position: 'relative',
    // backgroundColor: theme.palette.bg.white, //We removed the main background.
    [theme.breakpoints.down('sm')]: {
      padding: '25px 0',
    },
    '&.planExpirePadTop': {
      // paddingTop: 70,
    },
    '& .expiredStrape': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1,

      '& .snackbarBlock': {
        position: 'static',
        transform: 'none',
        background: theme.palette.bg.white,
        '& + .MuiSnackbar-root': {
          marginTop: 10,
        },
      },
      '& .community': {
        width: `calc(100% - 30px)`,
      },
      '& .alert': {
        width: '100%',
        padding: `${theme.spacing(1.5)}px  ${theme.spacing(2)}px`,
        '&.danger': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
        '&.danger2': {
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontWeight: 600,
        },
      },
    },
  },
  dashContentWrapperWithoutPadding: {
    paddingTop: 0,
  },
  dashboardMainWrap: {
    // paddingLeft: 64,
  },
  sidebarLayoutWrapper: {
    display: 'flex',
    marginTop: 105,
    height: 'calc(100vh - 105px)',
  },
  userProfileBlock: {
    '& .MuiListItem-root': {
      paddingTop: 6,
      paddingBottom: 6,
    },
  },
  boldText: {
    fontWeight: 700,
  },
  actionIcon: {
    minWidth: 35,
  },
  btnForPopup: {
    width: '100%',
  },

  userName: {
    fontSize: theme.fontSize.size9,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '160px',
    overflow: 'hidden',
  },
  email: {
    fontSize: theme.fontSize.size9,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '160px',
    overflow: 'hidden',
  },
  progressBarLine: {
    minHeight: 8,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.bg.whiteOff2,
  },
  primaryColor: {
    color: theme.palette.primary.light,
  },
  successIconColor: {
    color: theme.palette.alert.success,
    strokeWidth: 3,
  },
  notificationCount: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    fontSize: 10,
    fontWeight: 500,
    borderRadius: 0,
    boxShadow: theme.shadows[3],
  },
  badgeStyle: {
    '& .MuiBadge-badge': {
      height: 16,
      minWidth: 15,
      width: 15,
      backgroundColor: theme.palette.alert.warn2,
      border: `2px solid ${theme.palette.primary.contrastText}`,
      color: '#fff',
      fontSize: 10,
      right: '7%',
    },
  },
  notificationBlock: {
    backgroundColor: theme.palette.bg.whiteOff1,
    borderRadius: theme.shape.borderRadius,
    '& ul': {
      maxHeight: 412,
      overflowY: 'auto',
      overflowX: 'hidden',
      // '&::-webkit-scrollbar': {
      // 	display: 'none'
      // },
      '& li': {
        borderRadius: theme.shape.borderRadius,
        boxShadow: '0px 3px 6px #0000001A',
        backgroundColor: theme.palette.primary.contrastText,
        '&:nth-child(n+1)': {
          marginTop: theme.spacing(2),
        },
        '&:nth-child(1)': {
          marginTop: theme.spacing(0),
        },

        '& .MuiAvatar-circle': {
          height: 30,
          backgroundColor: theme.palette.primary.contrastText,
          boxShadow: '0px 2px 4px #00000029',
          width: 30,
        },
      },
    },
  },
  planDropdown: {
    '& .dropDownBody': {
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 6rem)',
    },
    '& .choosePlan': {
      '& .square': {
        width: 44,
        height: 44,
        backgroundColor: theme.palette.alert.alertWarnBg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
      },
      '& .circle': {
        width: 50,
        height: 50,
        backgroundColor: theme.palette.alert.alertWarnBg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 0,
      },
      '& .currentPlan': {
        borderBottom: `1px solid ${theme.palette.bg.whiteOff1}`,
        '& .MuiTypography-h6': {
          color: theme.palette.primary.main,
          lineHeight: theme.spacing[6],
          fontSize: theme.fontSize.size8,
          fontWeight: 500,
          marginBottom: 0,
        },
      },
      '& .expiredPlan': {
        textAlign: 'center',
        '& .MuiTypography-h6': {
          lineHeight: theme.spacing[6],
          fontSize: theme.fontSize.size8,
          fontWeight: 500,
          margin: 'auto',
          width: '90%',
        },
      },

      '& .leftDataPlan': {
        display: 'flex',
        alignItems: 'center',
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        '& .MuiTypography-h6': {
          color: theme.palette.secondary.main,
          lineHeight: theme.spacing[6],
          fontSize: theme.fontSize.size8,
          fontWeight: 500,
          //	marginBottom: 10,
        },
      },
      '& .upgradeActionPlan': {
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
        borderTop: `1px solid ${theme.palette.bg.whiteOff1}`,
      },
      '& .expired-btn': {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        backgroundColor: theme.palette.alert.alertWarnBg,
        color: theme.palette.primary.light,
        fontSize: theme.fontSize.size9,
        fontWeight: 500,
      },
    },
  },
  whatsNewBlock: {
    backgroundColor: theme.palette.bg.white,
    borderRadius: theme.shape.borderRadius,
    '& ul': {
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      '& li': {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.secondary.main,
        padding: `${theme.spacing(1.5)}px ${theme.spacing(2.5)}px `,
        cursor: 'pointer',
        '&:hover': {
          color: theme.palette.primary.light,
          backgroundColor: theme.palette.bg.whiteOff1,
        },
        '& .beamer_icon.active': {
          right: '85px',
          top: '15px',
        },
      },
    },
  },
  multiLangSupportPopup: {
    // width: 200,
    // border: '1px solid #DBDBDB',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.12)',
    borderRadius: 0,
    '&>.MuiPaper-elevation2': {
      border: `1px solid ${theme.palette.bg.whiteOff2}`,
      borderRadius: 0,
    },
  },
  multiLangList: {
    maxHeight: 300,
    overflow: 'auto',
    '& .MuiListItemIcon-root': {
      minWidth: 40,
    },
    '& .MuiListItem-root': {
      // paddingTop: theme.spacing(0.7),
      // paddingBottom: theme.spacing(0.7),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.bg.whiteOff1,
      },
    },
    '& .MuiListItemSecondaryAction-root': {
      display: 'flex',
    },

    '& .MuiTypography-root': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
    },
    '& .checkSvgIcon': {
      display: 'inline-block',
      marginLeft: '8px',
      //  marginTop:'3px',
    },
  },
  langTitle: {
    borderBottom: `1px solid ${theme.palette.bg.whiteOff2}`,
    position: 'relative',
    fontSize: 12,
    /* '&::after': {
      content: `" "`,
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%)',
      bottom: '93%',
      width: 0,
      height: 0,
      borderLeft: '.5rem solid transparent',
      borderRight: '.5rem solid transparent',
      borderBottom: `.7rem solid #fff`,
      clear: 'both',
    },
    '&::before': {
      content: `" "`,
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%)',
      bottom: '98%',
      width: 0,
      height: 0,
      borderLeft: '.5rem solid transparent',
      borderRight: '.5rem solid transparent',
      borderBottom: `.7rem solid #dbdbdb`,
      clear: 'both',
    }, */

    '& .baseText': {
      fontSize: '10px',
      textTransform: 'uppercase',
      marginLeft: '4px',
      backgroundColor: '#FFF0EC',
      color: theme.palette.primary.main,
      padding: '0px 5px',
      fontWeight: 'normal',
      display: 'inline-block',
      borderRadius: 0,
    },
  },
  langSuppoert: {
    margin: '0 16px',
    paddingLeft: 0,
  },
  svgDownTimeIcon: {
    width: 100,
    height: 100,
    color: theme.palette.text.grayColor1,
  },
  surveyStripeWrapper: {
    paddingTop: '2rem',
  },
  h100: {
    height: '100%',
  },
  popUpDescription: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'start',
    padding: `${theme.spacing(0)}px ${theme.spacing(3)}px`,
    '& ul': {
      paddingLeft: '1.5rem',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
      '& li': {
        fontSize: '0.875rem',
        lineHeight: 1.5,
      },
    },
    '& .infoIcon': {
      display: 'flex',
      alignItems: 'center',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
      padding: '0.5rem 1rem',
      background: "#FFF7ED",
      gap: '0.750rem',
      '& svg': {
        height: 20,
        width: 20,
      }
    },

  },
  headerContent: {
    padding: '0rem 2.5rem',
  },
  menuDivider: {
    alignSelf: 'center',
    height: '2rem',
  },
  menuMarginLeft: {
    marginLeft: '1.5rem',
  },
  dialogContent: {
    padding: '0px !important',
    '& .titleOFPopUp': {
      padding: `${theme.spacing(0)}px ${theme.spacing(3)}px`,
      '& .MuiTypography-root': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontWeight: '500'
      },
    },
  },
  publishImageContainer: {
    padding: theme.spacing(1),
  },
  modalActionButtonContainer: {
    padding: `${theme.spacing(0)}px ${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  }
}));


const WPlusLayout = ({ children, hasSidebarNav = true, isLoading }) => {
  const {
    dashContentWrapper,
    dashboardMainWrap,
    sidebarLayoutWrapper,
    boldText,
    closeBtn,
    h100,
    dashContentWrapperWithoutPadding
  } = useStyles();
  let history = useHistory();
  const { eventId, organiserId } = useParams();
  const pagePathname = history.location.pathname;
  const source = useSource();
  const match = useRouteMatch();
  const reduxData = useSelector(userInfoSelector, shallowEqual);
  const userInfo = useSelector(userInfoSelector, shallowEqual);
  const [isPlanExpired, setIsPlanExpired] = useState(false);
  const [isMenuOpen, setMenuOption] = useState(false);
  const [isWhatsNew, setWhatsNew] = useState(false);
  const [isPlanMenuOpen, setPlanMenuOption] = useState(false);
  const [chargeBeeData, setChargeBeeData] = React.useState({ access_url: '', isLoading: false });
  const dispatch = useDispatch();
  const [openSubscriptionPopup, toggleSubscriptionPopup] = React.useState(false);
  const [trackAmplitudeEvent] = useAmplitudeInstance();
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);


  const APICALLForCUSTOMDOMAIN = React.useCallback(
    (ACTION, reduxData, methodType, URL, headerData, bodyData, APICB) => {
      const [header, body] = API.generateHeader(reduxData, headerData, bodyData);
      let APIPromise;
      if (methodType === 'POST') {
        APIPromise = POSTAPIWITHCUSTOMDOMAIN(
          false,
          URL,
          source.AS,
          header,
          body,
          ProjectSetting.customBaseURL
        );
      }

      APIPromise.then((resp) => {
        if (resp.data.status === API.apiSuccessStatus) {
          if (resp.data.message)
            dispatch(setNewMessage({ message: resp.data.message, type: 'success', show: true }));
          APICB && APICB(ACTION, 'SUCCESS', resp.data);
        } else {
          API.errStatusHandler(resp, history, dispatch, () => {
            APICB && APICB(ACTION, 'ERROR', resp.data);
          });
        }
      }).catch(API.catchHandler);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    []
  );

  // as discussed with @avadhi. we do not use free plan  condition
  // useEffect(() => {
  //   //console.log("useeffect", currentDate_milli)
  //   //console.log("useeffect1", userInfo.UserInfo.subscription_end_date_milli);
  //   if (
  //     userInfo.UserInfo.planName === PricingPlan.FREE &&
  //     userInfo.UserInfo.subscriptionStatus === 'CANCELLED'
  //   ) {
  //     setIsPlanExpired(true);
  //     userInfo.UserInfo.isPlanExpired = isPlanExpired;
  //     dispatch(setUserInfo);
  //   }
  //   // else if(userInfo.UserInfo.subscription_meta_id != 1 && userInfo.UserInfo.subscriptionStatus{

  //   // }
  //   else {
  //     setIsPlanExpired(false);
  //     userInfo.UserInfo.isPlanExpired = isPlanExpired;
  //     dispatch(setUserInfo);
  //   }
  // }, [userInfo]);

  const handleScroll = () => {
    if (isMenuOpen) {
      setMenuOption(false);
    }
    if (isWhatsNew) {
      setWhatsNew(false);
    }
    if (isPlanMenuOpen) {
      setPlanMenuOption(false);
    }
  };
  const FETCH_CHARGEBEE_DATA = React.useCallback(() => {
    const data = {
      organiserId: reduxData.userId,
      userId: reduxData.userId,
      userPermission: reduxData.UserInfo.userPermission,
    };
    setChargeBeeData((plan) => ({ ...plan, isLoading: true }));
    APICALLForCUSTOMDOMAIN(
      'FETCH_CHRGEBEE_URL',
      data,
      'POST',
      MANAGE_SUBSCRIPTION,
      null,
      null,
      (ACTION, type, res) => {
        if (type === 'SUCCESS') {
          setChargeBeeData({ access_url: res.access_url, isLoading: false });
          toggleSubscriptionPopup(true);
        }
      }
    );
  }, [APICALLForCUSTOMDOMAIN, reduxData]);

  const handleUpgradeAlertCloseClick = React.useCallback(() => {
    const data = {
      organiserId: reduxData.userId,
      userId: reduxData.userId,
      userPermission: reduxData.UserInfo.userPermission,
    };

    const body = {
      contact_for_version_change: 0,
    };

    APICALLForCUSTOMDOMAIN(
      'CLOSE_UPGRADE_CONTACT_BUTTON',
      data,
      'POST',
      UPGRADE_MODAL_ACTIONS,
      null,
      body,
      (ACTION, type, res) => {
        if (type === 'SUCCESS') {
          dispatch(setUserInfo(body));
        }
      }
    );
  }, [APICALLForCUSTOMDOMAIN, reduxData]);

  const handleSurvey = React.useCallback(() => {
    dispatch(setSurvey({ isOpen: true }));
  }, []);

  const onToggleSideBar = React.useCallback(() => {
    setIsSideBarOpen((prev) => !prev);
  }, [isSideBarOpen]);

  const isProOrEnterpriseUser =
    !userInfo?.UserInfo?.planName ||
    userInfo?.UserInfo?.planName === PricingPlan.PRO ||
    userInfo?.UserInfo?.planName === PricingPlan.ENTERISE;

  const addTopMarginToHeader =
    isProOrEnterpriseUser &&
    userInfo?.UserInfo?.organiser_community_version === 1 &&
    userInfo.UserInfo.contact_for_version_change === 1;

  const isWebinar =
    userInfo.UserInfo.planName === PricingPlan.WEBINAR ||
    userInfo.UserInfo.planName === PricingPlan.WEBINAR_LITE;
  const isDigitalEvent = userInfo.UserInfo.planName === PricingPlan.DIGITAL_EVENTS;
  const isAllIn = userInfo.UserInfo.planName === PricingPlan.ALL_IN;

  const { UserInfo, UserInfo: { secondary_plans_details = [] } } = userInfo;

  const avlSecPlans = secondary_plans_details.length ? secondary_plans_details.map(eachPlan => eachPlan.planName) : [];
  const isOnlySecondaryPlanExits = SECONDARY_PLAN_LIST.includes(UserInfo.planName);
  const isMediaPlan = isOnlySecondaryPlanExits || avlSecPlans.includes(SECONDARY_PLAN_LIST[0]);
  const isSecondaryPlanCancelled =
    isMediaPlan ?
      userInfo.UserInfo.subscriptionStatus === 'CANCELLED' :
      !(secondary_plans_details.length && secondary_plans_details.find(eachPlan => eachPlan.planName === SECONDARY_PLAN_LIST[0]).isSubscriptionActive);
  const secPlanName = secondary_plans_details.length ? avlSecPlans[0] : userInfo.UserInfo.planName;
  const gracePeriodDays = userInfo.UserInfo?.is_on_grace_period === 1 && moment(userInfo.UserInfo.grace_period_until).diff(moment(), 'days')

  return (
    <>
      <BlurryBlobBackground />
      <Box component="section" className={hasSidebarNav ? dashboardMainWrap : ''}>
        <WPlusHeader
          hasSidebarNav={hasSidebarNav}
          isLoading={isLoading}
          isPlanExpired={isPlanExpired}
          isMenuOpen={isMenuOpen}
          setMenuOption={setMenuOption}
          isPlanMenuOpen={isPlanMenuOpen}
          setPlanMenuOption={setPlanMenuOption}
          isWhatsNew={isWhatsNew}
          setWhatsNew={setWhatsNew}
          onToggleSideBar={onToggleSideBar}
          isSideBarOpen={isSideBarOpen}
        />

        <Box
          className={sidebarLayoutWrapper}
          style={eventId ? { marginTop: 60, height: 'calc(100vh - 60px)' } : undefined}
        >
          {hasSidebarNav && <WPlusSidebar isLoading={isLoading} onCloseSideBar={onToggleSideBar} isOpen={isSideBarOpen} />}
          <Box
            id="dashContentWrapper"
            component="section"
            pt={4}
            pb={4}
            flex={1}
            style={{ minWidth: 0 }}
            className={
              isSecondaryPlanCancelled || isPlanExpired ||
                (userInfo.UserInfo.is_payment_due_or_auto_collection_off != undefined &&
                  userInfo.UserInfo.is_payment_due_or_auto_collection_off.auto_collection === 'off') ||
                // userInfo.UserInfo.subscriptionStatus === 'CANCEL_SCHEDULED' ||
                userInfo.UserInfo.subscriptionStatus === 'CANCELLED' ||
                (userInfo.UserInfo.subscriptionStatus === 'ACTIVE' &&
                  userInfo.UserInfo.isPaymentFailed === 1)
                ? `scroll-y planExpirePadTop ${dashContentWrapper} ${window.location.href.includes('plans') ? 'planWrapper' : ''
                }`
                : `scroll-y ${dashContentWrapper} ${window.location.href.includes('plans') ? 'planWrapper' : ''
                } ${addTopMarginToHeader ? 'planExpirePadTop' : ''} ${!eventId ? dashContentWrapperWithoutPadding : ''}`
            }
            onScroll={handleScroll}>
            {window.location.href.includes('billing') ? (
              <Box className={'expiredStrape'}>
                {userInfo.UserInfo.is_payment_due_or_auto_collection_off != undefined &&
                  userInfo.UserInfo.is_payment_due_or_auto_collection_off.auto_collection === 'off' &&
                  userInfo.UserInfo.is_payment_due_or_auto_collection_off.amount_due > 0 &&
                  !(isAllIn || isDigitalEvent || isWebinar) ? (
                  <Snackbar className="snackbarBlock" open={true}>
                    <Box
                      className={`alert danger`}
                      display="flex"
                      alignItems="center"
                      justifyContent="center">
                      <Box display="inline-flex" alignItems="center">
                        <Box display="inline-flex">
                          {' '}
                          <ErrorIcon />
                        </Box>
                        <Box ml={1}>
                          <Typography variant="body2" component="span">
                            Your payment of $
                            {userInfo.UserInfo.is_payment_due_or_auto_collection_off.amount_due} is
                            due on{' '}
                            {moment(
                              new Date(
                                userInfo.UserInfo.is_payment_due_or_auto_collection_off.due_date
                              ).getTime()
                            ).format(TIMESTAMP_FORMATS.MONTH_SHORT_DATE)}
                            .
                            <Box
                              className={`cursor-pointer ${boldText}`}
                              component="span"
                              style={{ textDecoration: 'underline' }}
                              onClick={() => {
                                FETCH_CHARGEBEE_DATA();
                              }}>
                              Manage Payment
                            </Box>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Snackbar>
                ) : (
                  false
                )}
              </Box>
            ) : (
              false
            )}

            {/* {isEnableSnake ? (
            <Box className={'expiredStrape'}>
              <Snackbar className="snackbarBlock" open={isEnableSnake}>
                <Box className={`alert danger2`} display="flex" alignItems="center">
                  <Typography variant="body2" component="p" className={`text-center ${w100}`}>
                    {surveyConfig?.label}
                    <Typography
                      variant="body2"
                      component="span"
                      className={feedBackForm}
                      onClick={handleSurvey}>
                      Give Feedback!
                    </Typography>
                  </Typography>
                </Box>
              </Snackbar>
            </Box>
          ) : (
            false
          )} */}

            {isProOrEnterpriseUser &&
              userInfo?.UserInfo?.organiser_community_version === 1 &&
              userInfo?.UserInfo?.contact_for_version_change === 1 && (
                <Box className={'expiredStrape'}>
                  <Snackbar className="snackbarBlock" open={true}>
                    <Box className={`alert danger`} display="flex" alignItems="center">
                      <Box
                        className="community"
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center">
                        <Box display="inline-flex">
                          {' '}
                          <ErrorIcon />
                        </Box>
                        <Box ml={1}>
                          <Typography variant="body2" component="span">
                            You need to upgrade to the new community. You can contact our customer
                            support at{' '}
                            <a href={`mailto:${supportEmail}`}>
                              {supportEmail}
                            </a>{' '}
                            for any help.
                          </Typography>
                        </Box>
                      </Box>
                      <IconButton className={closeBtn} onClick={handleUpgradeAlertCloseClick}>
                        <XIcon color="#fff" size={17} />
                      </IconButton>
                    </Box>
                  </Snackbar>
                </Box>
              )}

            {userInfo.UserInfo.subscriptionStatus != undefined &&
              userInfo.UserInfo.subscriptionStatus === 'CANCELLED' &&
              userInfo.UserInfo.planName === PricingPlan.FREE ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        <Typography variant="body2" component="span">
                          {userInfo.UserInfo.planName === PricingPlan.FREE &&
                            planExpireTypeDisplay(userInfo.UserInfo) === 'FREE TRIAL EXPIRED'
                            ? `Your FREE TRIAL Is Expired`
                            : `Your ${planExpireTypeDisplay(userInfo.UserInfo)}`}
                          {match.path !== '/plans' ? (
                            <Box
                              className={`cursor-pointer ${boldText}`}
                              component="span"
                              ml={0.5}
                              style={{ textDecoration: 'underline' }}
                              onClick={() => {
                                history.push('/plans');
                              }}>
                              {'Upgrade Now'}
                            </Box>
                          ) : (
                            false
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : userInfo.UserInfo.subscriptionStatus === 'CANCEL_SCHEDULED' &&
              // Check if Current Day lies between subscribtion End Date -15 days and  subscribtion End Date
              moment(new Date()).isBetween(
                new Date(
                  parseInt(userInfo.UserInfo.subscription_end_date_milli) - 15 * 24 * 60 * 60 * 1000
                ).getTime(), // Subscribtion End Date -15 days
                parseInt(userInfo.UserInfo.subscription_end_date_milli) // Subscribtion End Date
              ) && userInfo.UserInfo.is_on_grace_period !== 1 ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        <Typography variant="body2" component="span">
                          Your subscription will end on{' '}
                          {moment(parseInt(userInfo.UserInfo.subscription_end_date_milli)).format(
                            TIMESTAMP_FORMATS.MONTH_SHORT_DATE
                          )}
                          . To renew your subscription, reach out to your account manager. If you have
                          renewed your subscription, please ignore this message.
                          {/* <Box className={`cursor-pointer ${boldText}`} component="span" style={{ textDecoration: 'underline' }} onClick={()=>{history.push('/billing')}}>Abort Cancellation</Box> */}
                          {/* <Box
                          className={`cursor-pointer ${boldText}`}
                          ml={0.5}
                          component="span"
                          style={{ textDecoration: 'underline' }}
                          onClick={() => {
                            history.push('/billing');
                          }}>
                          {
                            // userInfo.UserInfo.is_team_member_loggedin === true ? false :
                            'GO TO BILLING'
                          }
                        </Box> */}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : (userInfo.UserInfo.subscriptionStatus === 'CANCELLED' &&
              userInfo.UserInfo.isPaymentFailed === 0) || userInfo.UserInfo?.is_on_grace_period === 1 ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        {userInfo.UserInfo?.is_on_grace_period === 1 ? (<Typography variant="body2" component="p">
                          Your subscription has ended, but you're in the grace period! <Typography className={`${boldText}`} variant="body2" component="span"> It ends in {gracePeriodDays} {gracePeriodDays === 1 ? 'day' : 'days'} on {moment(userInfo.UserInfo.grace_period_until)
                            .format(TIMESTAMP_FORMATS.MONTH_SHORT_DATE)}—</Typography>renew now to avoid losing access to all integrations. Contact your account manager for renewal.
                        </Typography>)
                          :
                          <Typography variant="body2" component="span">
                            {!(isAllIn || isDigitalEvent || isWebinar)
                              ? `Your Subscription has been cancelled. Kindly reactivate to continue using
                        the dashboard.`
                              : `Your subscription has ended. Talk to our sales team to reactivate your subscription.`}
                            {!(isAllIn || isDigitalEvent || isWebinar) ? (
                              <Box
                                className={`cursor-pointer ${boldText}`}
                                component="span"
                                style={{ textDecoration: 'underline' }}
                                onClick={() => {
                                  history.push('/billing');
                                }}>
                                {
                                  // userInfo.UserInfo.is_team_member_loggedin === true ? false :
                                  'GO TO BILLING'
                                }
                              </Box>
                            ) : null}
                          </Typography>
                        }
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : userInfo.UserInfo.subscriptionStatus === 'ACTIVE' &&
              userInfo.UserInfo.isPaymentFailed === 1 ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        <Typography variant="body2" component="span">
                          Payment declined. We could not process your payment because of insufficient
                          funds. Please update your payment method.{' '}
                          <Box
                            className={`cursor-pointer ${boldText}`}
                            component="span"
                            style={{ textDecoration: 'underline' }}
                            onClick={() => {
                              history.push('/billing');
                            }}>
                            Go to Billing
                          </Box>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : userInfo.UserInfo.subscriptionStatus === 'CANCELLED' &&
              userInfo.UserInfo.isPaymentFailed === 1 ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        <Typography variant="body2" component="span">
                          {!(isAllIn || isDigitalEvent || isWebinar)
                            ? `Your subscription has been cancelled due to non payment.Kindly reactivate to
                        continue using the dashboard.`
                            : `Your subscription has been cancelled due to non payment. Talk to our sales team to reactivate your subscription`}
                          {!(isAllIn || isDigitalEvent || isWebinar) ? (
                            <Box
                              className={`cursor-pointer ${boldText}`}
                              component="span"
                              style={{ textDecoration: 'underline' }}
                              onClick={() => {
                                history.push('/billing');
                              }}>
                              {
                                // userInfo.UserInfo.is_team_member_loggedin === true ? false :
                                'GO TO BILLING'
                              }
                            </Box>
                          ) : null}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : isSecondaryPlanCancelled &&
              planTypeDisplay(secPlanName) &&
              secondary_plans_details?.length ? (
              <Box className={'expiredStrape'}>
                <Snackbar className="snackbarBlock" open={true}>
                  <Box
                    className={`alert danger`}
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    <Box display="inline-flex" alignItems="center">
                      <Box display="inline-flex">
                        {' '}
                        <ErrorIcon />
                      </Box>
                      <Box ml={1}>
                        <Typography variant="body2" component="span">
                          {`Your ${planTypeDisplay(
                            secPlanName
                          )} subscription has been cancelled. Talk to our sales team to activate your subscription`}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Snackbar>
              </Box>
            ) : (
              ''
            )}
            {/* </>:''} */}


            {[
              '/events',
              '/events/upcoming',
              '/events/ended',
              '/events/ongoing',
              `/event/${eventId}/${organiserId}/`,
              `/event/${eventId}/${organiserId}`,
            ].includes(pagePathname) ? (
              <Box className={h100}>{children}</Box>
            ) : (
              children
            )}

            <NotificationBar />
          </Box>
        </Box>
      </Box>
      <IFramePopup
        url={chargeBeeData.access_url}
        isOpen={openSubscriptionPopup}
        onClose={() => toggleSubscriptionPopup(false)}
      />
    </>
  );
};

export default WPlusLayout;

